import { VerdictBadge, type Verdict } from '@kodprep/platform-ui/atomic';
import { useProblemSubmissions } from '@/lib/hooks/useProblemSubmissions';

interface Props {
  slug: string;
  onOpenSubmission: (id: string, verdict: string) => void;
}

export function SubmissionsTab({ slug, onOpenSubmission }: Props) {
  const { data, isLoading, isError } = useProblemSubmissions(slug);

  if (isLoading) {
    return <p className="p-6 text-sm text-muted-foreground">Loading submissions…</p>;
  }
  if (isError) {
    return <p className="p-6 text-sm text-destructive">Couldn’t load submissions.</p>;
  }
  if (!data || data.length === 0) {
    return (
      <div className="flex h-full flex-col items-center justify-center p-6 text-center">
        <p className="text-sm font-medium">No submissions yet</p>
        <p className="mt-1 text-sm text-muted-foreground">
          Run and submit your solution to see your history here.
        </p>
      </div>
    );
  }

  return (
    <div className="h-full overflow-y-auto">
      <table className="w-full text-sm">
        <thead className="sticky top-0 bg-muted/50 text-left text-xs uppercase text-muted-foreground">
          <tr>
            <th className="px-4 py-2 font-medium">Status</th>
            <th className="px-4 py-2 font-medium">Language</th>
            <th className="px-4 py-2 font-medium">Cases</th>
            <th className="px-4 py-2 font-medium">Submitted</th>
          </tr>
        </thead>
        <tbody>
          {data.map((s) => (
            <tr
              key={s.id}
              onClick={() => onOpenSubmission(s.id, s.verdict)}
              className="cursor-pointer border-b border-border/60 last:border-0 hover:bg-muted/40"
            >
              <td className="px-4 py-2">
                <VerdictBadge verdict={s.verdict as Verdict} />
              </td>
              <td className="px-4 py-2 font-mono">{s.language}</td>
              <td className="px-4 py-2 text-muted-foreground">
                {s.passed_cases}/{s.total_cases}
              </td>
              <td className="px-4 py-2 text-muted-foreground">
                {new Date(s.created_at).toLocaleString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
